import { render } from "./TheProfessionalConsultationUpdate.vue?vue&type=template&id=4061cb27&scoped=true&ts=true"
import script from "./TheProfessionalConsultationUpdate.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalConsultationUpdate.vue?vue&type=script&lang=ts"

import "./TheProfessionalConsultationUpdate.vue?vue&type=style&index=0&id=4061cb27&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4061cb27"]])

export default __exports__